import { render } from "./UserEmailAccountList.vue?vue&type=template&id=0720378a&scoped=true"
import script from "./UserEmailAccountList.vue?vue&type=script&lang=js"
export * from "./UserEmailAccountList.vue?vue&type=script&lang=js"

import "./UserEmailAccountList.vue?vue&type=style&index=0&id=0720378a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0720378a"]])

export default __exports__